import { cookieBotConfig } from '../../constants/cookieBotConfig';
import { EXPERIENCE_DOMAIN_CONFIG } from '../../constants/domainConfig';
import { COOKIE_DEFAULT_EXPIRE_TIME, COOKIE_DELETE_EXPIRE_TIME } from '../../constants/timers';

/** Function to set Cookie with expiry of 7 days
 * @param name cookie key
 * @param value cookie value
 * @param time expiration time in milliseconds (optional)
 * @param domain cookie domain (optional)
 */
export const setCookie = (
  name: string,
  value: string,
  domain?: string | undefined,
  expiryTime: number = COOKIE_DEFAULT_EXPIRE_TIME,
): void => {
  const date = new Date();

  date.setTime(date.getTime() + expiryTime);

  let cookie = `${name}=${value};expires=${date.toUTCString()};path=/;`;
  if (domain) {
    cookie += `domain=${domain};`;
  }
  document.cookie = cookie;
};

/** Function to get Cookie by key
 * @param name cookie key
 * @return cookie value
 */
export const getCookie = (name: string): string | undefined => {
  const value = `; ${document.cookie}`;
  const parts = value.split(`; ${name}=`);

  if (parts.length === 2) {
    const removedElem: string | undefined = parts.pop();
    if (removedElem) return removedElem.split(';').shift();
  }
};

/** Function to delete Cookie by key
 * @param name cookie key
 */
export const deleteCookie = (name: string): void => {
  const date = new Date();

  // Set it expire in -1 days
  date.setTime(date.getTime() + COOKIE_DELETE_EXPIRE_TIME);
  document.cookie = `${name}=;expires=${date.toUTCString()};path=/`;
};

export const getCsrf = (): string => {
  const experienceProps = getCookie('experience_props');
  return experienceProps ? JSON.parse(experienceProps.replace(/^"|"$/g, '').replace(/\\/g, '')).csrfToken : '';
};

/**
 * Cookie Bot Logic
 */

const makeCookieBotAccessible = (): void => {
  window.addEventListener('CookiebotOnDialogDisplay', () => {
    document.querySelectorAll('.CybotCookiebotDialogBodyLevelButtonWrapper label').forEach((element) => {
      element.setAttribute('role', 'tooltip');
    });
  });
};

export const createCookieBotScript = (): void => {
  if (document.querySelector('#Cookiebot') === null) {
    const host = window.location.hostname as EXPERIENCE_DOMAIN_CONFIG;
    const key = cookieBotConfig.apiKey[host]?.player;
    if (key) {
      const cookieScript = document.createElement('script');
      const locale = getCookie('locale_player') || 'en_us';
      cookieScript.setAttribute('src', cookieBotConfig.src);
      cookieScript.setAttribute('id', 'Cookiebot');
      cookieScript.setAttribute('data-culture', cookieBotConfig.localeMap[locale.toLowerCase()]);
      cookieScript.setAttribute('data-cbid', key);
      cookieScript.setAttribute('type', 'text/javascript');
      cookieScript.async = true;
      cookieScript.onload = makeCookieBotAccessible;
      document.head.appendChild(cookieScript);
    }
  }
};
